<div id="dummyContainer" appClick #dummyContainerRef class="dummy-container" style="pointer-events: none;"
  (click)="onDummyContainerClick($event)"></div>

<div [hidden]="isMinimized" [class.hidden-dialog]="isMinimized" class="dialog" id="{{componentId}}"
  style="pointer-events: auto;" [style.height.px]="dialogHeight ?? null" [style.width.px]="dialogWidth ?? null" cdkDrag
  [cdkDragBoundary]="dummyContainerRef" [cdkDragFreeDragPosition]="dragPosition" (cdkDragStarted)="onDragStart($event)"
  (cdkDragEnded)="onDragEnd($event)" (click)="onDialogClicked()">

  <div class="window-bar" style="z-index: 999999" id="{{windowBarId}}" (dblclick)="maximizeDialog()" cdkDragHandle>

    <div class="window-title w-100">
      <div class="m-0 d-flex" [hidden]="!data.title" (dblclick)="changeTitle($event)">
        <i class="fas me-1 my-auto fa-fw fa-fh title-icon" [ngClass]="'fa-fw fa-' + data.iconTitle"
          *ngIf="data.iconTitle && data.iconTitleBefore"></i>

        <span class="title-wrapper-window" *ngIf="!editTitle">
          {{ data.title }}
        </span>

        <a>
          <i class="fas ms-2 my-auto fa-fw fa-fh pointer toolbar-buttons fa-fw fa-pencil" [hidden]="editTitle"
            (click)="changeTitle()"></i>
        </a>

        <input *ngIf="!isMinimized" class="title-change-input" [value]="data.title" [hidden]="!editTitle"
          id="{{tabTitleId}}input" [cdkTrapFocus]="editTitle" [cdkTrapFocusAutoCapture]="editTitle"
          (keyup.enter)="saveTitleChange()" (dblclick)="$event.stopPropagation()" (blur)="saveTitleChange()"
          (mousedown)="$event.stopPropagation()">
      </div>
    </div>

    <div class="window-controls">
      <a [matMenuTriggerFor]="opacityMenu"><i class="fa-solid fa-glasses toolbar-buttons"></i></a>
      <a [matMenuTriggerFor]="windowSnapMenu"><i class="fa-solid fa-magnifying-glass me-1 toolbar-buttons"></i></a>
      <a class="minimize-button" (click)="onMinimize()"><i class="fa-solid fa-minus toolbar-buttons"></i></a>
      <a (click)="maximizeDialog()">
        <i class="fa-solid toolbar-buttons"
          [ngClass]="{'fa-window-maximize': !isMaximized, 'fa-window-restore': isMaximized}"></i>
      </a>
      <a class="close-button" (click)="closeDialog()">
        <i class="fa-solid fa-xmark toolbar-buttons close-button-icon"></i>
      </a>
    </div>
  </div>


  <div class="resize-icon" style="z-index: 999999;" appResize [(height)]="dialogHeight" [(width)]="dialogWidth"
    [positionX]="dragPosition.x" [positionY]="dragPosition.y">
    <i class="fas fa-grip-horizontal"></i>
  </div>

  <div class="dialog-body" [ngStyle]="data.dialogBodyStyle">
    <ng-template appInsertion></ng-template>
    <ngx-spinner [name]="componentId" bdColor="rgba(51, 51, 51, 0.8)" size="large"
      color="var(--kt-input-group-addon-color)" type="ball-pulse" [template]="spinnerTemplate"
      [fullScreen]="false"></ngx-spinner>
  </div>

</div>

<div *ngIf="isMinimized" id="{{tabId}}" class="minimized-tab"
  style="justify-content: space-between; pointer-events: auto; touch-action: none;" (dblclick)="reopenDialog()">
  <div class="d-flex flex-row">
    <p class="me-auto m-0 h-100 title-wrapper-minimized" (dblclick)="changeTitle($event)" *ngIf="!editTitle"
      id="{{tabTitleId}}" [matTooltip]="data.title || ''">
      {{data.title}}
    </p>
    <input class="title-change-input me-2 m-0" value="{{data.title}}" [hidden]="!editTitle" id="{{tabTitleId}}input"
      [cdkTrapFocus]="editTitle" [cdkTrapFocusAutoCapture]="editTitle" (dblclick)="$event.stopPropagation()"
      (blur)="saveTitleChange()" (keyup.enter)="saveTitleChange()" [matTooltip]="data.title || ''">

    <span class="me-2" [hidden]="editTitle"><i class="fa-solid fa-pencil tab-icon" (click)="changeTitle()"></i></span>
    <span class="me-2"><i class="fa-solid fa-window-maximize tab-icon" (click)="reopenDialog()"></i></span>
    <span class="me-2"><i class="fa-solid fa-xmark tab-icon" (click)="closeDialog()"></i></span>
  </div>
</div>

<mat-menu #opacityMenu>
  <div class="slider-container" cdkMenu>
    <mat-slider [color]="'success'" min="1" max="85" step="1" percentage="85">
      <input matSliderThumb [value]="currentOpacity" (valueChange)="onOpacityChange($event)">
    </mat-slider>
  </div>
</mat-menu>


<mat-menu #windowSnapMenu>
  <div class="snap-container" style="margin-bottom: 5px;">
    <div class="snap-row" style="margin-bottom: 2px;">
      <div class="snap-item-left-top" (click)="moveDialogToTopLeft()"></div>
      <div class="snap-item-right-top" (click)="moveDialogToTopRight()"></div>
    </div>
    <div class="snap-row">
      <div class="snap-item-left-bottom" (click)="moveDialogToBottomLeft()"></div>
      <div class="snap-item-right-bottom" (click)="moveDialogToBottomRight()"></div>
    </div>
  </div>
  <div class="snap-container">
    <div class="snap-row">
      <div class="snap-item-left" (click)="moveDialogToLeft()"></div>
      <div class="snap-item-right" (click)="moveDialogToRight()"></div>
    </div>
  </div>
</mat-menu>